import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { QRCodeSVG } from 'qrcode.react'
import type { MfaSecret } from '../../services/mfaApi'

/** The QR code to scan, with the secret to type for an app that cannot scan. */
const AuthenticatorSetup: React.FC<{ secret: MfaSecret }> = ({ secret }) => (
  <Stack spacing={1.5} alignItems="center">
    <Typography variant="body2" sx={{ alignSelf: 'stretch' }}>
      Scan this with an authenticator app (Microsoft Authenticator, Google Authenticator, 1Password or similar), then enter the 6-digit code it shows.
    </Typography>
    {/* White behind the code in both themes: phone cameras read dark-on-light. */}
    <Box sx={{ p: 1.5, bgcolor: '#fff', borderRadius: 1, lineHeight: 0 }}>
      <QRCodeSVG value={secret.otpauth_uri} size={176} level="M" title="QR code for your authenticator app" />
    </Box>
    <Typography variant="caption" color="text.secondary" sx={{ alignSelf: 'stretch' }}>
      Cannot scan? Enter this key in the app instead:
    </Typography>
    <Box
      component="code"
      data-testid="mfa-secret"
      sx={{ fontFamily: 'monospace', fontSize: '0.95rem', letterSpacing: '0.08em', wordBreak: 'break-all', userSelect: 'all' }}
    >
      {secret.secret.replace(/(.{4})/g, '$1 ').trim()}
    </Box>
  </Stack>
)

export default AuthenticatorSetup
